var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "full-height pa-3", attrs: { id: "meeting_participant" } },
    [
      _vm.meeting.is_connected &&
      (!_vm.show_aux_track || _vm.isSharingScreen()) &&
      !_vm.meeting.isCobrowsing() &&
      !_vm.meeting.is_whiteboard_active
        ? _c(
            "v-row",
            _vm._l(_vm.video_peers, function (peer, index) {
              return _c(
                "v-col",
                {
                  key: peer.id,
                  class: "pa-2 " + _vm.getValOrBlankColClass(index),
                  attrs: { cols: _vm.getValOrBlankCols(index) },
                },
                [
                  _vm.meeting.local_peer.roleName != "waiting-room" ||
                  peer.isLocal
                    ? _c(
                        "v-card",
                        {
                          staticClass: "rounded-lg",
                          attrs: {
                            loading: _vm.loading_video_plugin && peer.isLocal,
                          },
                        },
                        [
                          _vm.meeting.peer_video_enabled[peer.id]
                            ? _c("video", {
                                ref: peer.id,
                                refInFor: true,
                                class: `rounded-lg ${
                                  _vm.grid[index] ? _vm.grid[index].class : ""
                                } ${peer.isLocal ? " mirror" : ""}`,
                                staticStyle: {
                                  "max-width": "100%",
                                  width: "100%",
                                  "object-fit": "cover",
                                  "margin-bottom": "-6px",
                                },
                                attrs: {
                                  "aspect-ratio": 16 / 9,
                                  autoplay: "",
                                  playsinline: "",
                                },
                                domProps: { muted: peer.isLocal },
                              })
                            : _c(
                                "v-card",
                                {
                                  staticStyle: {
                                    "max-width": "100%",
                                    "margin-bottom": "-6px",
                                  },
                                },
                                [
                                  _c(
                                    "v-responsive",
                                    {
                                      class: `rounded-lg ${
                                        _vm.grid[index]
                                          ? _vm.grid[index].class
                                          : ""
                                      }`,
                                      attrs: { "aspect-ratio": 16 / 9 },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "fill-height",
                                          staticStyle: {
                                            width: "100%",
                                            display: "flex",
                                            "align-items": "center",
                                            "justify-content": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-h4 font-weight-bold",
                                            },
                                            [_vm._v(_vm._s(peer.name))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                          _c(
                            "v-overlay",
                            {
                              staticStyle: {
                                "justify-content": "start",
                                "align-items": "end",
                              },
                              attrs: { opacity: "0", absolute: true },
                            },
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "mx-2 white--text mb-2",
                                  attrs: {
                                    color: `${
                                      peer.roleName == "coach"
                                        ? "orange"
                                        : "grey"
                                    } darken-4`,
                                    small: "",
                                  },
                                },
                                [
                                  _vm._v(" " + _vm._s(peer.name) + " "),
                                  _vm.meeting.local_peer.roleName != "guest"
                                    ? _c("span", { staticClass: "ml-1" }, [
                                        _vm._v(
                                          "(" +
                                            _vm._s(
                                              peer.roleName.toUpperCase()
                                            ) +
                                            ")"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ml-1 white--text",
                                      attrs: { icon: "", "x-small": "" },
                                      on: {
                                        click: function ($event) {
                                          ;["host", "coach"].includes(
                                            _vm.meeting.local_peer.roleName
                                          ) &&
                                            _vm.meeting.enablePeerAudio(
                                              peer,
                                              !_vm.meeting.peer_audio_enabled[
                                                peer.id
                                              ]
                                            )
                                        },
                                      },
                                    },
                                    [
                                      !_vm.meeting.peer_audio_enabled[peer.id]
                                        ? _c(
                                            "v-icon",
                                            { attrs: { color: "red" } },
                                            [_vm._v("mdi-microphone-off")]
                                          )
                                        : _c("v-icon", [
                                            _vm._v("mdi-microphone"),
                                          ]),
                                    ],
                                    1
                                  ),
                                  _vm.meeting.permissions &&
                                  _vm.meeting.permissions.changeRole
                                    ? _c("meeting-participant-menu", {
                                        attrs: { peer: peer },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-overlay",
                            {
                              attrs: {
                                absolute: true,
                                value:
                                  peer.roleName == "waiting-room" &&
                                  ["host", "coach"].includes(
                                    _vm.meeting.local_peer.roleName
                                  ),
                              },
                            },
                            [
                              _vm.meeting.local_peer.roleName == "host"
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        "x-large": "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.meeting.hmsActions.changeRole(
                                            peer.id,
                                            "guest",
                                            true
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " Admit " +
                                          _vm._s(peer.name.toUpperCase()) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm.show_aux_track && !_vm.isSharingScreen()
        ? _c(
            "v-container",
            { staticClass: "mt-0 full-height pa-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    _vm._l(_vm.video_peers, function (peer) {
                      return _c(
                        "v-card",
                        { key: peer.id, staticClass: "rounded-lg mb-2" },
                        [
                          _c("video", {
                            ref: peer.id,
                            refInFor: true,
                            class: `rounded-lg video-sixth-height ${
                              peer.isLocal ? " mirror" : ""
                            }`,
                            staticStyle: {
                              width: "100%",
                              "object-fit": "cover",
                              "margin-bottom": "-6px",
                            },
                            attrs: {
                              "aspect-ratio": 16 / 9,
                              autoplay: "",
                              playsinline: "",
                            },
                            domProps: { muted: peer.isLocal },
                          }),
                          _vm.meeting.is_connected
                            ? _c(
                                "v-overlay",
                                {
                                  staticStyle: {
                                    "justify-content": "start",
                                    "align-items": "end",
                                  },
                                  attrs: { absolute: true, opacity: "0" },
                                },
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 white--text",
                                      attrs: {
                                        color: `${
                                          peer.roleName == "coach"
                                            ? "orange"
                                            : "grey"
                                        } darken-4`,
                                        small: "",
                                      },
                                    },
                                    [
                                      _vm._v(" " + _vm._s(peer.name) + " "),
                                      !_vm.meeting.peer_audio_enabled[peer.id]
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { color: "red" },
                                            },
                                            [_vm._v("mdi-microphone-off")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          peer.roleName == "waiting-room" &&
                          ["host", "coach"].includes(
                            _vm.meeting.local_peer.roleName
                          )
                            ? _c(
                                "v-overlay",
                                { attrs: { absolute: true } },
                                [
                                  _vm.meeting.local_peer.roleName == "host"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.meeting.hmsActions.changeRole(
                                                peer.id,
                                                "guest",
                                                true
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Admit " +
                                              _vm._s(peer.name.toUpperCase()) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c("v-col", { attrs: { cols: "10" } }, [
                    _c("div", [
                      _c("video", {
                        ref: "screenshare_video",
                        class: `rounded-lg video-full-height`,
                        staticStyle: {
                          "max-width": "100%",
                          width: "100%",
                          "object-fit": "contain",
                          "margin-bottom": "-36px",
                        },
                        attrs: {
                          "aspect-ratio": 16 / 9,
                          autoplay: "",
                          playsinline: "",
                        },
                      }),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.meeting.isLivestreaming &&
      _vm.meeting.local_peer &&
      _vm.meeting.local_peer.roleName == "livestream-viewer"
        ? _c(
            "v-container",
            { staticClass: "mt-0 full-height pa-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("video", {
                      ref: "livestream_video",
                      class: `video-full-height`,
                      staticStyle: {
                        "max-width": "100%",
                        width: "100%",
                        "object-fit": "contain",
                        "margin-bottom": "-36px",
                      },
                      attrs: {
                        "aspect-ratio": 16 / 9,
                        autoplay: "",
                        playsinline: "",
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.meeting.is_connected &&
      _vm.meeting.cobrowse_session &&
      _vm.meeting.isCobrowsing()
        ? _c(
            "v-container",
            { staticClass: "mt-0 full-height pa-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    _vm._l(_vm.video_peers, function (peer) {
                      return _c(
                        "v-card",
                        { key: peer.id, staticClass: "rounded-lg mb-2" },
                        [
                          _c("video", {
                            ref: peer.id,
                            refInFor: true,
                            class: `rounded-lg video-sixth-height ${
                              peer.isLocal ? " mirror" : ""
                            }`,
                            staticStyle: {
                              width: "100%",
                              "object-fit": "cover",
                              "margin-bottom": "-6px",
                            },
                            attrs: {
                              "aspect-ratio": 16 / 9,
                              autoplay: "",
                              playsinline: "",
                            },
                            domProps: { muted: peer.isLocal },
                          }),
                          _vm.meeting.is_connected
                            ? _c(
                                "v-overlay",
                                {
                                  staticStyle: {
                                    "justify-content": "start",
                                    "align-items": "end",
                                  },
                                  attrs: { absolute: true, opacity: "0" },
                                },
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 white--text",
                                      attrs: {
                                        color: `${
                                          peer.roleName == "coach"
                                            ? "orange"
                                            : "grey"
                                        } darken-4`,
                                        small: "",
                                      },
                                    },
                                    [
                                      _vm._v(" " + _vm._s(peer.name) + " "),
                                      !_vm.meeting.peer_audio_enabled[peer.id]
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { color: "red" },
                                            },
                                            [_vm._v("mdi-microphone-off")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          peer.roleName == "waiting-room" &&
                          ["host", "coach"].includes(
                            _vm.meeting.local_peer.roleName
                          )
                            ? _c(
                                "v-overlay",
                                { attrs: { absolute: true } },
                                [
                                  _vm.meeting.local_peer.roleName == "host"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.meeting.hmsActions.changeRole(
                                                peer.id,
                                                "guest",
                                                true
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Admit " +
                                              _vm._s(peer.name.toUpperCase()) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c("v-col", { attrs: { cols: "10" } }, [
                    _c("iframe", {
                      staticClass: "video-full-height rounded-lg",
                      staticStyle: { width: "100%", "margin-bottom": "-36px" },
                      attrs: {
                        src:
                          _vm.meeting.local_peer.roleName == "host"
                            ? _vm.meeting.cobrowse_session.leader_link +
                              "?name=" +
                              _vm.meeting.local_peer.name
                            : _vm.meeting.cobrowse_session.follower_link +
                              "?name=" +
                              _vm.meeting.local_peer.name,
                        allow: "autoplay *; display-capture *; geolocation *;",
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.meeting.is_connected && _vm.meeting.is_whiteboard_active
        ? _c(
            "v-container",
            { staticClass: "mt-0 full-height pa-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    _vm._l(_vm.video_peers, function (peer) {
                      return _c(
                        "v-card",
                        { key: peer.id, staticClass: "rounded-lg mb-2" },
                        [
                          _c("video", {
                            ref: peer.id,
                            refInFor: true,
                            class: `rounded-lg video-sixth-height ${
                              peer.isLocal ? " mirror" : ""
                            }`,
                            staticStyle: {
                              width: "100%",
                              "object-fit": "cover",
                              "margin-bottom": "-6px",
                            },
                            attrs: {
                              "aspect-ratio": 16 / 9,
                              autoplay: "",
                              playsinline: "",
                            },
                            domProps: { muted: peer.isLocal },
                          }),
                          _vm.meeting.is_connected
                            ? _c(
                                "v-overlay",
                                {
                                  staticStyle: {
                                    "justify-content": "start",
                                    "align-items": "end",
                                  },
                                  attrs: { absolute: true, opacity: "0" },
                                },
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 white--text",
                                      attrs: {
                                        color: `${
                                          peer.roleName == "coach"
                                            ? "orange"
                                            : "grey"
                                        } darken-4`,
                                        small: "",
                                      },
                                    },
                                    [
                                      _vm._v(" " + _vm._s(peer.name) + " "),
                                      !_vm.meeting.peer_audio_enabled[peer.id]
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { color: "red" },
                                            },
                                            [_vm._v("mdi-microphone-off")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          peer.roleName == "waiting-room" &&
                          ["host", "coach"].includes(
                            _vm.meeting.local_peer.roleName
                          )
                            ? _c(
                                "v-overlay",
                                { attrs: { absolute: true } },
                                [
                                  _vm.meeting.local_peer.roleName == "host"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.meeting.hmsActions.changeRole(
                                                peer.id,
                                                "guest",
                                                true
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Admit " +
                                              _vm._s(peer.name.toUpperCase()) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c("v-col", { attrs: { cols: "10" } }, [
                    _c("div", {
                      staticClass: "video-full-height rounded-lg",
                      staticStyle: { width: "100%", "margin-bottom": "-36px" },
                      attrs: { id: "wt-container" },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("v-overlay", {
        attrs: {
          value:
            _vm.meeting.is_connected &&
            _vm.meeting.local_peer &&
            ["coach", "qa"].includes(_vm.meeting.local_peer.roleName) &&
            _vm.meeting.isCobrowsing(),
          absolute: true,
          opacity: "0",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }